import { render } from "./all-data.vue?vue&type=template&id=4c8d8c96&scoped=true"
import script from "./all-data.vue?vue&type=script&lang=ts"
export * from "./all-data.vue?vue&type=script&lang=ts"

import "./all-data.vue?vue&type=style&index=0&id=4c8d8c96&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4c8d8c96"

export default script